import services from "../services";

export const viewStatisticsActions = {
  getViewStatistics,
  setStatisticsBiller,
};

function getViewStatistics(data, setLoading) {
  return services.viewStatisticsService.getViewStatistics(
    data,
    setLoading
  );
}

function setStatisticsBiller(billerId, fiNumber) {
  return services.viewStatisticsService.setStatisticsBiller(
    billerId,
    fiNumber
  );
}
